<template>
  <div>
  
    <div class="container-fluid">
      <div class="row page">
        <overview-card :leads="leads" 
                       :branches="branches" 
                       :selectedLead="selectedLead"
                       :selectedBranch="selectedBranch"
                       :leadStats="leadStats"
                       :branchStats="branchStats"
                       @leadSelected="selectLead($event)"
                       @branchSelected="selectBranch($event)"
                       leadType="Charity"
                       leadPluralType="Charities"
                       oppositeLeadType="Retailer"
                       oppositeLeadTypePlural="Retailers"
                       ></overview-card>
      </div>
    </div>
    
  </div>
</template>
<script>

  import CharityLeadsService from '../../../services/CharityLeadsService';
  import StatsService from '../../../services/StatsService';
  import DropsService from '../../../services/DropsService';
  import OverviewCard from '../../../components/Cards/OverviewCard';

  export default {
    name: 'charity-overview',

    components: {
      OverviewCard
    },

    created() {
      this.init()
    },

    data() {
       return {
        leads: [],
        branches: [],
        selectedLead: null,
        selectedBranch: null,
        leadStats: null,
        branchStats: null,
      };
    },

    methods:{
      /**
       * 
       */
      init(){
        this.fetchLeads();
      },

      /**
       * 
       */
      async fetchLeads() {
        try {
          const leadsRes = await CharityLeadsService.getAll();
          this.leads = leadsRes.data;
        }
        catch(err) {
          console.log('Error fetching Leads', err);
          alert('Oops! Somthing went wrong, the page may not have loaded correctly. Please try again.');
        }
      },

      /**
       * @param {object} lead 
       */
      async selectLead(lead) {
        this.selectedLead = lead;
        this.selectedBranch = null;
        try {
          const statsRes = await StatsService.getCharityLeadStats(this.selectedLead.id);
          this.branches = statsRes.data.myBranches;
          this.leadStats = statsRes.data;
        }
        catch(err) {
          console.log('Error fetching Branches', err);
          alert('Oops! Somthing went wrong, the page may not have loaded correctly. Please try again.');
        }
      },

      /**
       * @param {object} branch 
       */
      async selectBranch(branch) {
        this.selectedBranch = branch;
        try {
          const statsRes = await StatsService.getCharityStats(branch.id);
          const dropRes = await DropsService.getAllPopulated({where:{charityId: branch.id}, limit: 10});
          this.branchStats = {relatedBranches:statsRes.data.relatedBranches, drops:dropRes.data, totalDrops: statsRes.data.totalDrops, totalIssues: statsRes.data.totalIssues};
        }
        catch(err) {
          console.log('Error fetching Drops', err);
          alert('Oops! Somthing went wrong, the page may not have loaded correctly. Please try again.');
        }
      },

    }
  };
</script>

<style>
    .page {
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 8rem);
  }
</style>

<style lang="scss" scoped>

</style>
